/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentDataExtractorConfigurationTypes.yaml
import { PartiallyConstructible } from '../utils/utils';
/** @internal */
export var DocumentDataExtractorConfigurationElement;
(function (DocumentDataExtractorConfigurationElement) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'DateValidationConfiguration':
                return new DateValidationConfiguration(source);
            case 'EuropeanHealthInsuranceCardConfiguration':
                return new EuropeanHealthInsuranceCardConfiguration(source);
            case 'MRZFallbackConfiguration':
                return new MrzFallbackConfiguration(source);
            case 'DocumentDataExtractorCommonConfiguration':
                return new DocumentDataExtractorCommonConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    DocumentDataExtractorConfigurationElement.From = From;
})(DocumentDataExtractorConfigurationElement || (DocumentDataExtractorConfigurationElement = {}));
/**
Date validation configuration.
This configuration element does not enable the scanning of any document types by itself.
Add to recognizer configuration to require date validation checks for specific document types.
*/
export class DateValidationConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DateValidationConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'DateValidationConfiguration';
        /**
          Minimum year that is considered valid.
          
          Default is 0
          */
        this.minYear = 0;
        /**
          Maximum year that is considered valid.
          
          Default is 2999
          */
        this.maxYear = 2999;
        if (source.minYear !== undefined) {
            this.minYear = source.minYear;
        }
        if (source.maxYear !== undefined) {
            this.maxYear = source.maxYear;
        }
        if (source.fieldTypeName !== undefined) {
            this.fieldTypeName = source.fieldTypeName;
        }
        else {
            throw new Error('fieldTypeName must be present in constructor argument');
        }
    }
}
export const EuropeanHealthInsuranceCardIssuingCountryValues = [
    'AUSTRIA',
    'BELGIUM',
    'BULGARIA',
    'CROATIA',
    'CYPRUS',
    'CZECH_REPUBLIC',
    'DENMARK',
    'ESTONIA',
    'FINLAND',
    'FRANCE',
    'GERMANY',
    'GREECE',
    'HUNGARY',
    'IRELAND',
    'ITALY',
    'LATVIA',
    'LITHUANIA',
    'LUXEMBOURG',
    'MALTA',
    'NETHERLANDS',
    'POLAND',
    'PORTUGAL',
    'ROMANIA',
    'SLOVAKIA',
    'SLOVENIA',
    'SPAIN',
    'SWEDEN',
    'SWITZERLAND',
];
/**
European Health Insurance Card (EHIC) configuration element. Add to extractor configuration to scan EHICs.
*/
export class EuropeanHealthInsuranceCardConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<EuropeanHealthInsuranceCardConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'EuropeanHealthInsuranceCardConfiguration';
        /**
          If an expected country is selected, validation rules for the given country are used,
          and if the expected country cannot be inferred or the inferred country doesn't  match the given country,
          the result of extract() will be IncompleteValidation.
          */
        this.expectedCountry = null;
        if (source.expectedCountry !== undefined) {
            this.expectedCountry =
                source.expectedCountry != null
                    ? EuropeanHealthInsuranceCardIssuingCountryValues.includes(source.expectedCountry)
                        ? source.expectedCountry
                        : null
                    : null;
        }
    }
}
/**
MRZ fallback configuration element.
This configuration element does not enable the scanning of any document types by itself.
Add to extractor configuration to enable recognizing the MRZ only, specifically for documents that are otherwise not supported.
Note that this may enable scanning of documents that were not enabled through the accepted document types.
*/
export class MrzFallbackConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<MrzFallbackConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'MRZFallbackConfiguration';
        /**
          List of ISO 3166-1 alpha-3 country codes for which the MRZ fallback is enabled. (e.g. "DEU" for Germany).
          */
        this.acceptedCountries = [];
        /**
          List of MRZ document types for which MRZ fallback is enabled.
          */
        this.acceptedMRZTypes = [];
        if (source.acceptedCountries !== undefined) {
            this.acceptedCountries = source.acceptedCountries.map((it) => {
                return it;
            });
        }
        if (source.acceptedMRZTypes !== undefined) {
            this.acceptedMRZTypes = source.acceptedMRZTypes.map((it) => {
                return it;
            });
        }
    }
}
/**
Convenience configuration element for enabling the scanning of multiple document types with a common configuration.
Add to extractor configuration to enable the scanning of multiple document types.
*/
export class DocumentDataExtractorCommonConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorCommonConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'DocumentDataExtractorCommonConfiguration';
        if (source.acceptedDocumentTypes !== undefined) {
            this.acceptedDocumentTypes = source.acceptedDocumentTypes.map((it) => {
                return it;
            });
        }
        else {
            throw new Error('acceptedDocumentTypes must be present in constructor argument');
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorConfigurationTypes.js.map